import Axios from 'axios'
import store from './store'
import router from './router'

let baseURL = 'http://localhost:1337/api/v1'

if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'production') {
  baseURL = '../api/v1'
}

const backendAPI = Axios.create({
  baseURL: baseURL,
})

backendAPI.interceptors.response.use((response) => {
  if (store.state.maintenance) {
    store.dispatch('setMaintenance', false)
    router.push('/')
  }
  return response
}, (error) => {
  const response = error.response
  if (!response || response.status === 503) {
    store.dispatch('setMaintenance', true)
    router.push('/maintenance')
  } else {
    if (store.state.maintenance) {
      store.dispatch('setMaintenance', false)
      router.push('/')
    }
  }
  return Promise.reject(error)
})

export default backendAPI
